{
  "dateRange": {
    "from": "From",
    "to": "To",
    "placeholder": "YYYY-MM-DD",
    "triggerAriaLabel": "Date range",
    "clear": "Clear",
    "exactDates": "Exact dates",
    "fromPrefix": "From {{date}}",
    "toPrefix": "Until {{date}}",
    "bothDates": "{{start}} — {{end}}",
    "errors": {
      "startAfterEnd": "Start date cannot be after end date",
      "required": "Date is required",
      "invalidDate": "Invalid date"
    },
    "prevMonth": "Previous month",
    "nextMonth": "Next month",
    "chips": {
      "today": "Today",
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "thisMonth": "This month",
      "lastMonth": "Last month",
      "thisYear": "This year"
    },
    "views": {
      "day": "Day",
      "month": "Month",
      "year": "Year"
    }
  }
}
